export default "__VITE_ASSET__DeY$eBp___"